<template>
  <div>
    <div class="bannerVideo">
      <video
        width="auto"
        :src="videoAbout"
        id="whVideo"
        loop="loop"
        x5-video-player-type="h5-page"
        autoplay
        webkit-playsinline
        x5-playsinline
        playsinline
        muted
      >
        <source :src="videoAbout" type="video/mp4" />
        <source :src="videoAbout" type="video/webm" />
        <source :src="videoAbout" type="video/ogg" />
      </video>
    </div>
    <div :id="maxscrollTop ? 'commonGoTopNav' : ''" class="navBox">
      <div class="commonNavBox">
        <div
          :class="tabOpt == index ? 'tabList tabOpt' : 'tabList'"
          v-for="(item, index) in tabList"
          :key="index"
          @click="handleClick(index,true)"
        >
          <div class="text">{{ item.catname }}</div>
        </div>
      </div>
    </div>
    <div class="module">
      <div class="moduleContent">
        <div class="tab moduleTitle" v-if="tabList[0].catname">{{tabList[0].catname}}</div>
        <div class="brandInfo"  v-if='brandInfoBoxList.info'>
          <img :src="brandInfoBoxList.info.img" alt="" />
          <div class="brandInfoContent">
            <div class="title">{{brandInfoBoxList.info.title}}</div>
            <div class="content" v-html="brandInfoBoxList.info.content"></div>
          </div>
        </div>
        <div class="brandInfoListBox">
          <div
            class="brandInfoList"
            v-for="(item, index) in brandInfoList"
            :key="index"
          >
            <div class="imgBox"><img :src="$imgUrl.imgUrl(item.image)" alt="" /></div>
            <div class="numBox">
              <div class="num">
                <countTo
                  :startVal="0"
                  :endVal="item.num"
                  :duration="2000"
                  separator=""
                ></countTo>
              </div>
              <div class="unit">{{ item.unit }}</div>
            </div>
            <div class="name">{{ item.title }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="module">
      <div class="moduleContent">
        <div class="tab moduleTitle" v-if="tabList[1].catname">{{tabList[1].catname}}</div>
        <div class="cultureBox fourColumns">
          <div
            class="cultureList"
            v-for="(item, index) in cultureList"
            :key="index"
          >
            <div class="title">{{ item.title }}</div>
            <div class="content">{{ item.description }}</div>
            <img :src="item.thumb" alt="" />
          </div>
        </div>
      </div>
    </div>
    <div class="module">
      <div class="moduleContent">
        <div class="tab moduleTitle" v-if="tabList[2].catname">{{tabList[2].catname}}</div>
        <div class="brandDevelop">
          <div
            class="timelineList"
            v-for="(item, index) in timelineList"
            :key="index"
          >
            <div class="timeText">{{ item.title }}</div>
            <div class="time_line">
              <div class="time_icon">
                <div class="circle"></div>
              </div>
              <div class="line"></div>
            </div>
            <div class="content">{{ item.description }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="module">
      <div class="moduleContent">
        <div class="tab moduleTitle" v-if="tabList[3].catname">{{tabList[3].catname}}</div>
        <div class="fourColumns barndStrength">
          <div
            class="barndStrengthList"
            v-for="(item, index) in brandStrengthList"
            :key="index"
          >
            <img :src="item.image" alt="" />
            <div class="title">{{ item.title }}</div>
          </div>
        </div>
        <div class="patentSwiper">
          <swiper :options="patentOption" ref="patentSwiper">
            <swiper-slide
              v-for="(patentItem, patentIndex) in patentList"
              :key="patentIndex"
            >
              <div class="patentBox">
                <img :src="patentItem" alt="" mode="aspectFill" />
              </div>
            </swiper-slide>
          </swiper>
          <div class="swiper-button-prev" slot="button-prev">
            <i class="el-icon-arrow-left"></i>
          </div>
          <div class="swiper-button-next" slot="button-next">
            <i class="el-icon-arrow-right"></i>
          </div>
        </div>
      </div>
    </div>
    <div class="module">
      <div class="moduleContent">
        <div class="tab moduleTitle" v-if="tabList[4].catname">{{tabList[4].catname}}</div>
        <div class="fourColumns productFeature">
          <div
            class="productFeatureList listBox"
            v-for="(item, index) in productFeatureList"
            :key="index"
          >
            <img :src="item.thumb" alt="" />
            <div class="title">{{ item.title }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="module">
      <div class="moduleContent">
        <div class="tab moduleTitle">跨界合作</div>
        <div class="fourColumns cooperate">
          <div
            class="cooperateList"
            v-for="(item, index) in cooperateList"
            :key="index"
            @click="linkUrl(item.url)"
          >
            <img :src="item.image" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
</style>
<script>
import * as axios from "../../src/axios/api.js";
import imgUrl from "../../src/utils/imgUrl.js";
import countTo from "vue-count-to";
export default {
  components: {
    countTo,
  },
  data() {
    return {
      patentOption: {
        loop: true,
        loopedSlides: 4,

        slidesPerView: 4, //页面分组显示，这里显示为3组
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      timelineList: [
        
      ],
      patentList: [
        
      ],
      tabOpt: 0,
      videoAbout:'',
      activeName: "0",
      maxscrollTop: false,
      banner: {},
      companyImg: "",
      tabList: [
          {catname:''},
          {catname:''},
          {catname:''},
          {catname:''},
          {catname:''}
      ],
      brandInfoBoxList:[],
      brandInfoList: [],
      cultureList: [
      ],
      cooperateList: [
        
      ],
      productFeatureList:[],
      brandStrengthList:[],
    };
  },
  watch: {
    $route: {
      handler: function (val, oldVal) {
        if (val.query.index) {
          this.index = val.query.index;
          setTimeout(() => {
            this.handleClick(val.query.index,false);
          }, 500);
        }
        
      },
      // 深度观察监听
      deep: true,
    },
  },
  created() {
    let id = this.$route.query.id;
    this.getAboutList(id);
    this.getCooperate();
   
    // let index = this.$route.query.index;
    // this.handleClick(index,false);
  },
  mounted() {
    if (this.$route.query.index) {
      var that=this
      that.index = that.$route.query.index;
      setTimeout(() => {
        that.handleClick(that.index,true);
      }, 500);
    }
    window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    start(e) {
      e.preventDefault();
    },
    getAboutList(id) {
      axios.get("/api/about",{catid:id}).then((res) => {
        if(res.code==1){
          this.videoAbout=imgUrl.imgUrl(res.data.video);
          this.tabList=res.data.category;
          this.brandInfoBoxList=res.data.category[0];
          var cultureList=res.data.category[1].list;
          for(var i in cultureList){
            cultureList[i].thumb=imgUrl.imgUrl(cultureList[i].thumb);
          }
          this.cultureList=cultureList;
          var timelineList=res.data.category[2].list;
          for(var i in timelineList){
            timelineList[i].thumb=imgUrl.imgUrl(timelineList[i].thumb);
          }
          this.timelineList=timelineList;
          this.brandInfoBoxList.info.img=imgUrl.imgUrl(this.brandInfoBoxList.info.thumb);
          var brandStrengthList=res.data.category[3].custom;
          for(var i in brandStrengthList){
            brandStrengthList[i].image=imgUrl.imgUrl(brandStrengthList[i].image);
          }
          this.brandStrengthList=brandStrengthList;
          var patentList=res.data.category[3].info.image;
          
          for(var i in patentList){
            patentList[i]=imgUrl.imgUrl(patentList[i]);
          }
          
          this.patentList=patentList
          var productFeatureList=res.data.category[4].list;
          for(var i in productFeatureList){
            productFeatureList[i].thumb=imgUrl.imgUrl(productFeatureList[i].thumb);
          }
          this.productFeatureList=productFeatureList
        }
      });
    },
    //跨界合作
    getCooperate(){
      axios.get("/api/links").then((res) => {
        if(res.code==1){
          var cooperateList= res.data
          for(var i in cooperateList){
            cooperateList[i].image=imgUrl.imgUrl(cooperateList[i].image);
          }
          this.cooperateList=cooperateList;
        }
      });
    },
    handleClick(index,isCurrentPage) {
      // var index = tab.index
      var that = this;
      that.tabOpt = index;
      let jump = document.querySelectorAll(".tab");
      let total = '';
      if(jump[index].offsetTop!==undefined){
        if(isCurrentPage){
          total=jump[index].offsetTop - 70;
        }else{
          total=jump[index].offsetTop - 140;
        }
      }
      let distance =
        document.documentElement.scrollTop || document.body.scrollTop;
      // 平滑滚动，时长500ms，每10ms一跳，共50跳
      let step = total / 50;
      if (total > distance) {
        smoothDown();
      } else {
        let newTotal = distance - total;
        step = newTotal / 50;
        smoothUp();
      }
      function smoothDown() {
        if (distance < total) {
          distance += step;
          document.body.scrollTop = distance;
          document.documentElement.scrollTop = distance;
          setTimeout(smoothDown, 10);
        } else {
          document.body.scrollTop = total;
          document.documentElement.scrollTop = total;
        }
      }
      function smoothUp() {
        if (distance > total) {
          distance -= step;
          document.body.scrollTop = distance;
          document.documentElement.scrollTop = distance;
          setTimeout(smoothUp, 10);
        } else {
          document.body.scrollTop = total;
          document.documentElement.scrollTop = total;
        }
      }
    },
    handleScroll() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (scrollTop > 1088) {
        for(var i in this.brandInfoBoxList.custom){
          this.brandInfoBoxList.custom[i].num=parseInt(this.brandInfoBoxList.custom[i].num);
        }
        this.brandInfoList = this.brandInfoBoxList.custom;
      }
      if (scrollTop > 1004) {
        this.maxscrollTop = true;
      } else {
        this.maxscrollTop = false;
      }
    },
    // 更多 跳转
    goMore(e) {
      if (e == "new") {
        this.$router.push({ name: "newslist" });
      } else if (e == "firm") {
        this.$router.push({ name: "firmlist" });
      }
    },
    linkUrl(url) {
      if(url){
        window.location.href = url;
      }
    },
    jump(selector) {
      let anchor = this.$el.querySelector(selector);
      //anchor.scrollIntoView();
      let total = anchor.offsetTop - 80;
      document.body.scrollTop = total;
      document.documentElement.scrollTop = total;
    },
    // getAnchor(anchor) {
    //   if (anchor) {
    //     let selector = "#" + anchor;
    //     //页面还在渲染,不能使用scrollIntoView(),所以设置延时等渲染完成
    //     setTimeout(() => {
    //       this.jump(selector);
    //     }, 500);
    //     let num = anchor.substring(6);
    //     this.activeName = num;
    //   }
    // },
  },
};
</script>
<style scoped>
.bannerVideo {
  width: 100%;
  height: 960px;
}
.bannerVideo video {
  width: 100%;
  object-fit: fill;
  height: 100%;
}
.companyBg span {
  color: white;
}
/* /deep/.companyList .companyPublic p { margin-top: 8px;} */
.fourColumns {
  display: flex;
}
.fourColumns .listBox {
  width: 25%;
}
.cultureBox .cultureList {
  width: 330px;
  margin-right: 24px;
  border: 2px solid #f4f7f2;
}
.cultureBox .cultureList:last-of-type,
.barndStrengthList:last-of-type {
  margin-right: 0;
}
.cultureBox .cultureList .title {
  margin-top: 30px;
  margin-bottom: 24px;
  font-size: 24px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  line-height: 28px;
}
.cultureBox .cultureList .content {
  margin-bottom: 36px;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
  line-height: 28px;
}
.cultureBox .cultureList img,
.barndStrengthList img {
  display: block;
  width: 100%;
  height: 360px;
  background: #f4f7f2;
}
.barndStrengthList {
  width: 332px;
  margin-right: 24px;
  margin-bottom: 120px;
}
.barndStrengthList .title {
  font-size: 24px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  line-height: 28px;
  margin-top: 46px;
}
.productFeatureList img {
  display: inline-block;
  width: 136px;
  height: 136px;
}
.productFeatureList .title {
  font-size: 26px;
  font-weight: 400;
  color: #333333;
  line-height: 28px;
  margin-top: 40px;
}
.cooperate {
  flex-wrap: wrap;
  margin: 0 auto;
  margin-bottom: 85px;
}
.cooperateList {
  margin: 5px 6px;
}
/* .cooperateList:nth-child(6n){margin-right: 0;} */
.cooperateList img {
  display: inline-block;
  width: 220px;
  height: 140px;
  transition: all 0.6s;
}
.cooperateList img:hover {
  transform: scale(1.1);
}
.module {
  padding-top: 120px;
  display: flex;
  justify-content: center;
  text-align: center;
}
.module .moduleTitle {
  margin-bottom: 48px;
  font-size: 36px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #009144;
}
.module .moduleContent {
  width: 73vw;
}
.brandInfo,
.brandInfoListBox {
  display: flex;
}
.brandInfo {
  height: 420px;
}
.brandInfo img {
  flex: 1;
  height: 100%;
}
.brandInfo .brandInfoContent {
  flex: 1;
  background: #009144;
  color: #ffffff;
  padding: 30px 100px;
  box-sizing: border-box;
}
.brandInfo .brandInfoContent .title {
  font-size: 24px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  line-height: 54px;
  position: relative;
}
.brandInfo .brandInfoContent .title::after{
    content: "";
    position: absolute;
    bottom: 0;
    left: 50%;
    margin-left: -25px;
    height: 2px;
    width: 50px;
    background-color: #FFF;
}
.brandInfo .brandInfoContent .content {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  line-height: 28px;
  margin-top:24px;
  text-align: left;
}
.brandInfoListBox {
  background: #f4f7f2;
  height: 226px;
  align-items: center;
}
.brandInfoList {
  flex: 1;
}
.brandInfoList img {
  display: block;
  margin: 0 auto;
  margin-bottom: 10px;
  width: 52px;
  height: 52px;
}
.brandInfoList .numBox {
  display: flex;
  align-items: flex-end;
  justify-content: center;
}
.brandInfoList .numBox .num {
  font-size: 50px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
}
.brandInfoList .numBox .unit {
  font-size: 14px;
  color: #666;
  line-height: 42px;
}
.brandInfoList .name {
  font-size: 14px;
  font-weight: 400;
  color: #333333;
  line-height: 42px;
}
/*轮播*/
.patentSwiper {
  max-width: 1400px;
  display: flex;
  justify-content: center;
  position: relative;
}
.patentSwiper .swiper-container {
  width: 100%;
}
.patentSwiper .patentBox {
  width: 17.2vw;
  margin: 0 auto;
  text-align: center;
  cursor: pointer;
}
/* .patentSwiper .patentBox .name{margin-top:40px; font-size: 26px;font-family: Microsoft YaHei;font-weight: 400;color: #333333;line-height: 42px;}
.patentSwiper .patentBox .text{font-size: 14px;font-family: Microsoft YaHei;font-weight: 400;color: #666666;line-height: 42px;} */
.patentSwiper img {
  display: block;
  width: 100%;
  max-height: 459px;
}
/* .patentSwiper .patentBox:hover{width: 2vw;}
.patentSwiper .patentBox:hover img{height: 550px;} */
/* .patentSwiper .patentBox:hover .name,.patentSwiper .patentBox:hover .text{width: 336px;} */
.patentSwiper .swiper-slide {
  display: flex;
  align-items: center;
}
/deep/.patentSwiper .swiper-button-prev,
.patentSwiper .swiper-container-rtl .swiper-button-next {
  left: -104px;
  background-image: initial;
  width: 54px;
  height: 54px;
  background: #f5f5f5;
  border-radius: 50%;
  line-height: 54px;
  text-align: center;
  font-size: 26px;
}
/deep/.patentSwiper .swiper-button-next,
.patentSwiper .swiper-container-rtl .swiper-button-prev {
  right: -104px;
  background-image: initial;
  width: 54px;
  height: 54px;
  background: #f5f5f5;
  border-radius: 50%;
  line-height: 54px;
  text-align: center;
  font-size: 26px;
}
/deep/.patentSwiper .swiper-button-prev,
.patentSwiper .swiper-button-next:focus {
  outline: none;
}
.brandDevelop{
  margin-top:80px;
}
.timelineList {
  display: flex;
  justify-content: center;
}
.timelineList:first-child .content{
  opacity: 0;
}
.timeText {
  width: 120px;
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  margin-right: 16px;
  text-align: right;
  margin-top:-8px;
}
.timelineList .content {
  width: 720px;
  height: 72px;
  background: #f5f5f5;
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
  line-height: 72px;
  margin-left: 60px;
  margin-top:-32px;
}
.time_line {

}
.time_line .time_icon {
  width: 12px;
  height: 12px;
  background: #8ebba3;
  border-radius: 50%;
  padding: 3px;
  box-sizing: border-box;
}
.time_line .time_icon .circle {
  width: 100%;
  height: 100%;
  background: #317651;
  border-radius: 50%;
}
.time_line .line {
  width: 1px;
  height: 145px;
  background: #e8f1ec;
  margin: 0 auto;
}
</style>